import { render, staticRenderFns } from "./ButtonChatPersonFeatured.vue?vue&type=template&id=37888b5a&scoped=true&"
import script from "./ButtonChatPersonFeatured.vue?vue&type=script&lang=js&"
export * from "./ButtonChatPersonFeatured.vue?vue&type=script&lang=js&"
import style0 from "./ButtonChatPersonFeatured.vue?vue&type=style&index=0&id=37888b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37888b5a",
  null
  
)

export default component.exports